'use strict';

//
// Select2 Initialization
//

$.fn.select2.defaults.set('theme', 'bootstrap5');
$.fn.select2.defaults.set('width', '100%');
$.fn.select2.defaults.set('selectionCssClass', ':all:');
